// root '../../../';

// dependencies
import { Child } from 'pym.js';
import { select } from 'd3-selection';
import { json } from 'd3-fetch';
import { timeParse } from 'd3-time-format';
import Zion from './utils/Zion';

// polyfills
// import fetch from 'unfetch';
import './utils/polyfills'; // (includes Array.findIndex && Array.find)

// utils & graphic
import { stylePremium } from './utils/helpers';
import config from './config';
import graphic from './graphic';

// styles
import './styles/index.scss';

/* develblock:start */
import meta from './data/meta.json';

// Parse time
const parseTime = timeParse('%Y-%m-%d');

const pkg = require('../package.json');

if (process.env.NODE_ENV === 'development') {
  console.clear();
}

// eslint-disable-next-line  no-use-before-define
window.pymChild = new Child({ renderCallback: draw });

window.onload = () => {
  // necessary evil for right now

  if (process.env.NODE_ENV === 'development') {
    Object.keys(meta).forEach((id) => {
      const node = document.querySelector(`.${id}`);

      if (node) {
        node.innerHTML = meta[id];
      }
    });
  }

  const { pymChild } = window;
  pymChild.sendHeight();

  // If embedded, send Zion page view event
  if (window.pymChild.parentUrl) {
    const zion = new Zion(pkg.name, pymChild.parentUrl.split('?')[0]);
  }
};

const CNNPolitics = false;
const CNNBusiness = false;

stylePremium(CNNPolitics, CNNBusiness);

function draw(initialWidth) {
  const container = select('#graphic');
  container.html('');

  const fallbackWidth = container.node().clientWidth || 600;
  const safeWidth = initialWidth !== fallbackWidth ? fallbackWidth : initialWidth;
  const isMobile = safeWidth <= 500;

  const heightMultiplier = isMobile ? 1 : 9 / 16;
  const initialHeight = heightMultiplier * safeWidth;

  const props = { initialWidth: safeWidth, initialHeight, isMobile };

  // Query data
  json('https://ix.cnn.io/data/gun-violence-archive/gva-incidents.json')
  // Clean up to years
    .then((res) => {
      // Empty array for return statement
      const data = [];
      // Years already covered (add to in the map below)
      const years = [];
      // Simplify the response
      const incidents = res.data;

      // Re-map data by year should look like:
      //  [ {
      //  year: 2021
      //  values: [ incidents ]
      // } ... ]
      incidents.map((d) => {
        // Year of this incident
        const year = parseYear(d.timestampDate);
        // If our array of years includes that year already
        if (years.includes(year)) {
          // Find the index of that year
          const foundI = data.findIndex(obj => obj.year == year);
          // Append that object with the incident info
          data[foundI].year = year;
          data[foundI].value = [...data[foundI].value, d];
        } else {
          // If this year hasn't been done, add it as a new object
          data.push({
            year,
            value: [d],
          });
          // Add to our years array to track what we've covered
          years.push(year);
        }
      });
      // Pass on data
      return data;
    // Sort by year (ascending)
    }).then((data) => {
      data.sort((a, b) => (parseInt(a.year) - parseInt(b.year)));
      return data;
    // Sort each year's incidents by date;
    }).then((data) => {
      data.forEach((obj) => {
        obj.value.map((incident) => {
          incident.timestampDate = parseTime(incident.timestampDate);
        });
        obj.value = obj.value.sort((a, b) => a.timestampDate - b.timestampDate);
      });
      return data;
    })
    .then((data) => {
      const graphicConfig = config(props, data);
      // Send to graphic
      graphic(graphicConfig, container, isMobile);
      pymChild.sendHeight();
    });
}


// Helpers
function parseYear(t) {
  return t.split('-')[0];
}
